// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error404_wrapper__2WpHM","title":"Error404_title__1_7jg","subtitle":"Error404_subtitle__19TTw"};